// @ts-nocheck
import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Observable, of, combineLatest, BehaviorSubject, Subscription, from, merge, Observer } from 'rxjs';
import { Meta, Criterio } from 'src/app/_models/meta';
import { concatMap, distinctUntilChanged, filter, flatMap, map, mergeMap, shareReplay, startWith, tap, toArray } from 'rxjs/operators';
import { Unidad } from 'src/app/_models/unidad';
import { EstudioService } from '../../estudio.service';
import { GlobalService } from 'src/app/_services/global.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';
import { RetroalimentacionService } from '../_services/retroalimentacion.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GLMLanguageService } from 'src/app/_services/glm-language.service';
import { DynamicBarService } from 'src/app/_components/dynamic-bar/dynamic-bar.service';
import { Title } from '@angular/platform-browser';
import { ClassroomService } from 'src/app/_services/classroom.service';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { MatDialog } from '@angular/material/dialog';
import { RetroalimentacionDevolverDialogoComponent } from '../../retroalimentacion-devolver-dialogo/retroalimentacion-devolver-dialogo.component';
import { AlumnoRetroalimentacion } from '../models/alumno-retroalimentacion';
import { Location } from '@angular/common'
import { AutoevaluacionService } from '../../autoevaluacion/autoevaluacion.service';

@Component({
  selector: 'app-retroalimentacion-grid',
  standalone: false,
  templateUrl: './retroalimentacion-grid.component.html',
  styleUrls: ['./retroalimentacion-grid.component.scss', '../retroalimentacion.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetroalimentacionGridComponent implements OnInit, OnDestroy {

  metas$: Observable<Meta[]>;
  unidad$: Observable<Unidad>;
  evento$: Observable<any>;
  eventos$: Observable<any[]>;
  fechasEvento$: Observable<any[]>;

  criterios$: Observable<Criterio[]>;

  columnas$: Observable<string[]>;

  eventoUnidadId: number;
  unidadId: number;
  materiaId: number;
  materias$: Observable<any>;
  alumnos$: Observable<AlumnoRetroalimentacion[]>;
  eventoIndex$: Observable<{index: number, eventos: any}>;
  fecha = '';
  fechaActual$: Observable<string>;
  alumnoForm = new UntypedFormControl(-1);
  fechaForm = new UntypedFormControl('');
  materiaForm = new UntypedFormControl(0);
  checkForm = new UntypedFormGroup({});
  mostrarAutoevaluacionForm = new UntypedFormControl(false);
  mostrarAutoevaluacion$ = this.mostrarAutoevaluacionForm.valueChanges.pipe(startWith(false), shareReplay(1));
  mcpsActuales = [];

  alumnoFormSubscription: Subscription;
  materiaFormSubscription = this.materiaForm.valueChanges.subscribe({
    next: (res) => {
      this.navegarMateria(res);
    }
  });

  eventoUnidadId$ = this.route.paramMap.pipe(map(data => data['params'].eventoUnidadId)).pipe(
    tap(data => {
      this.eventoUnidadId = +data;
      this.loadingSubject.next(false);
    })
  );

  private loadingSubject = new BehaviorSubject(true);
  loading$ = this.loadingSubject.asObservable();

  constructor(
    private estudioService: EstudioService,
    private globalService: GlobalService,
    private retroalimentacionService: RetroalimentacionService,
    private route: ActivatedRoute,
    private languageService: GLMLanguageService,
    private dynamicBarService: DynamicBarService,
    private titleService: Title,
    private router: Router,
    private classroomService: ClassroomService,
    private customAlertService: CustomAlertService,
    private matDialog: MatDialog,
    private location: Location,
  ) {
  }

  ngOnInit(): void {

    this.unidadId = +this.route.snapshot.paramMap.get('unidadId');
    if (this.route.snapshot.paramMap.get('alumnoId')) {
      this.alumnoForm.setValue(+this.route.snapshot.paramMap.get('alumnoId'));
    }
    this.materiaId = +this.route.snapshot.paramMap.get('materiaId');
    if (this.materiaId) {
      this.materiaForm.setValue(this.materiaId, {emitEvent: false});
    }
    this.unidad$ = this.retroalimentacionService.getUnidadEventos(this.unidadId).pipe(
      tap(data => {
        // this.languageService.setLanguage({nickName: data.idioma});
        // this.dynamicBarService.setBarra('estudio-retroalimentacion', {unidad: data});
      })
    );

    this.evento$ = this.eventoUnidadId$.pipe(
      mergeMap(id => {
        return this.estudioService.getEventoDataRetroalimentacionV2(id).pipe(
          tap(data => {
            this.titleService.setTitle(`${data.nombre} - Estudio`);
            let fechas = [];
            data.materias.forEach(item => {
              fechas = this.globalService.unionArrays(fechas, item.fechas);
            });
            this.languageService.setLanguage({nickName: data.unidad.idioma});
            this.dynamicBarService.setBarra('estudio-retroalimentacion', {unidad: data.unidad});
          })
        );
      }),
      shareReplay(1)
    );

    this.eventos$ = this.unidad$.pipe(
      map(data => {
        return data.eventos.filter(evento => {
          return evento.evento.categoria.ordenAgrupador === 11;
        });
      }), shareReplay(1)
    );

    this.eventoIndex$ = combineLatest([this.eventos$, this.eventoUnidadId$]).pipe(
      map(([data, eventoUnidadId]) => {
        return {index: data.findIndex(item => item.id === +eventoUnidadId), eventos: data};
      }),
      shareReplay(1)
    );

    this.fechasEvento$ = combineLatest([this.evento$, this.materiaForm.valueChanges.pipe(startWith(this.materiaForm.value))]).pipe(
      map(([data, materia]) => {
        let res = [];
        data.materias.forEach(item => {
          if (+materia === 0 || item.id === +materia) {
            res = this.globalService.unionArrays(res, item.fechas);
          }
        });
        return res;
      }),
      shareReplay(1)
    );

    this.fechaActual$ = combineLatest([this.fechasEvento$, this.fechaForm.valueChanges.pipe(startWith(''))]).pipe(
      map(([fechas, fecha]) => {
        if (fecha === '') {
          const fechaActual = fechas.sort((a, b) => moment(b).millisecond() - moment(a).millisecond())[0];
          this.fechaForm.setValue(fechaActual, {emitEvent: false});
          if (fechaActual === undefined) {
            this.location.back()
            window.location.reload()
            this.customAlertService.setCustomMessage({
              tipo: 'error',
              texto: `El evento no tiene fecha para los alumnos en contexto.`
            });
            return '0000-00-00';
          }
          return fechaActual;
        } else {
          return fecha;
        }
      }),
      tap(data => this.fecha = data),
      shareReplay(1)
    );

    this.materias$ = combineLatest([this.evento$, this.fechaForm.valueChanges.pipe(startWith(''))]).pipe(
      map(([evento, fechaActual]) => {
        if (fechaActual === '') {
          return evento.materias;
        } else {
          return evento.materias.filter(materia => {
            return materia.fechas.findIndex(fecha => fecha.substring(0, 10) === fechaActual.substring(0, 10)) > -1;
          });
        }
      })
    );

    const eventoMateriaIds$ = this.unidadEventosMateriaIdsObservable(this.materias$, this.fechaActual$, this.materiaForm.valueChanges.pipe(
      startWith(this.materiaForm.value))).pipe(map(data => {
        return data.map(item => item.id);
      }),
      map(data => [...data]),
      distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
    );

    const eventoMateriaIdsCourswork$ =
      this.unidadEventosMateriaIdsObservable(this.materias$, this.fechaActual$, this.materiaForm.valueChanges.pipe(
      startWith(this.materiaForm.value))).pipe(map(data => {
        return data.filter(item => {
          return item.courseWorkId != null;
        }).map(item => item.id);
      }));

    const alumnos$ = eventoMateriaIds$.pipe(
      concatMap(res => {
        return from(res).pipe(
          mergeMap(id => {
            return this.estudioService.alumnosRetroalimentacionEvento(id);
          }),
          toArray(),
          map(data => {
            let resp = [];
            data.forEach(item => {
              resp = resp.concat(item);
            });
            this.checkForm = new UntypedFormGroup({});
            resp.forEach(alumno => {
              this.checkForm.addControl(alumno.id, new UntypedFormControl(false));
            });
            return resp;
          })
        );
      }),
      shareReplay(1)
    );

    // const alumnosConAutoevaluacion$ = this.alumnosConAutoevaluacion(alumnos$, eventoMateriaIds$);

    const alumnosConCambios$ = this.alumnosConCambios(alumnos$);

    this.alumnos$ = this.alumnosConSubmissions(alumnosConCambios$, eventoMateriaIdsCourswork$).pipe(
      tap((data) => {
        this.loadingSubject.next(true);
      })
    );

    const metas$ = this.evento$.pipe(
      map(data => data.metas));

    this.criterios$ = combineLatest([metas$, this.languageService.getLanguageObservable()]).pipe(
      map(([data, language]) => {
        const metas = language.activeLang ? this.languageService.setIdiomaMetas(data, language.activeLang.nickName) : data;
        let resp = [];
        data.forEach(element => {
          element.criterios.forEach(criterio => {
            criterio.metaData = {
              codigo: element.codigo + '-' + element.id,
              id: element.id,
              desc: element.txtIdioma
            };
          });
          resp = resp.concat(element.criterios);
        });
        return resp;
      }),
      shareReplay(1)
    );

    this.columnas$ = this.criterios$.pipe(
      map(data => {
        return ['alumnos'].concat(data.map(item => item.metaData.id.toString()+'-'+item.id.toString()));
      }),
      shareReplay(1)
    );

    this.alumnoForm.valueChanges.subscribe(res => {
      const routerParams = ['/', 'estudio', 'unidad', '' + this.unidadId, 'retroalimentacion'].concat(
        ['evento', '' + this.eventoUnidadId].concat(
          this.materiaId ? ['materia', '' + this.materiaId] : [])
      );
      this.router.navigate(routerParams, { queryParams: { alumnoId: res } });
    });
  }

  navegarEvento(eventoIndex, eventos) {
    const materia = this.materiaForm.value;
    const eventoFuturo = eventos[eventoIndex].eventoMaterias.filter(item => item.materiaCursoPeriodoID === materia);
    if (eventoFuturo.length > 0) {
      const alumnoId = this.alumnoForm.value;
      const routerParams = ['/', 'estudio', 'unidad', this.unidadId, 'retroalimentacion'].concat(
        ['evento', eventos[eventoIndex].id].concat(
        this.materiaId ? ['materia', this.materiaId] : [])
      );
      this.router.navigate(routerParams, { queryParams: { alumnoId: this.alumnoForm.value } });
    } else {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `El evento al cual desea ir no tiene fechas para los alumnos en contexto.`
      });
    }
  }

  navegarMateria(id: number) {
    const alumnoId = this.alumnoForm.value;
    const routerParams = ['/', 'estudio', 'unidad', this.unidadId, 'retroalimentacion'].concat(
      ['evento', this.eventoUnidadId].concat(['materia', id])
    );
    this.router.navigate(routerParams, { queryParams: { alumnoId: this.alumnoForm.value } });
  }

  navegarEstudiante(alumnoId) {
    this.alumnoForm.setValue(alumnoId);
  }

  abrirLink(tarea) {
    if (tarea) {
      window.open(tarea.url, '_blank');
    }
  }

  classroomActions(alumnos: any[], accion: string) {
    if (alumnos.length > 0) {
      this.matDialog.open(RetroalimentacionDevolverDialogoComponent, {
        width: '100%',
        height: '100%',
        maxWidth: '100vw !important',
        maxHeight: 'calc(-64px + 100vh)',
        position: { bottom: '0'},
        // width: '55%',
        disableClose: true,
        data: {
          alumnos,
          accion,
          evento: this.evento$,
          datosAlumnos: this.alumnos$,
          fecha: this.fechaForm.value,
          materia: this.materiaForm.value,
          eventoId: this.eventoUnidadId
        }
      });
    } else {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `Seleccione al menos un alumno.`
      });
    }
  }

  // Metodo que retorna el obserbable con los ids de unidad evento materia que están siendo evaluados en el contexto de filtrado actual.
  unidadEventosMateriaIdsObservable(materias$: Observable<any[]>, fechaActual$: Observable<string>, materiaActual$) {
    return combineLatest([materias$, fechaActual$, materiaActual$]).pipe(
      map(([materias, fechaActual, materiaActual]) => {
        const materiasFiltradas = materiaActual === 0 ? materias : materias.filter(item => item.id === materiaActual);
        let unidadEventoMaterias = [];
        materiasFiltradas.forEach(item => {
          const next = item.eventoMaterias.find(ele => ele.fechaAplicar.slice(0, 10) === fechaActual.slice(0, 10));
          if (next) {
            unidadEventoMaterias = unidadEventoMaterias.concat(next);
          }
        });
        return unidadEventoMaterias;
      }),
      filter(item => item.length > 0),
    );
  }

  alumnosConCambios(alumnos$: Observable<AlumnoRetroalimentacion[]>) {
    return combineLatest([alumnos$, merge(this.estudioService.cambiosEvento$, this.classroomService.cambios$)]).pipe(
      map(([alumnos, cambios]) => {
        if (cambios) {
          if (cambios['alumnoId']) {
            const alumnoActual = alumnos.find(alumno => alumno.id === cambios['alumnoId']);
            if (alumnoActual) {
              const criterioIndex = alumnoActual.criterios.findIndex(
                criterio => +criterio.criterioId === +cambios['criterioId'] &&
                  criterio.unidadEventoMateriaId === cambios['unidadEventoMateriaId']);
              if (criterioIndex > -1) {
                if (cambios.accion === 'delete') {
                  alumnoActual.criterios.splice(criterioIndex, 1);
                } else if (cambios.accion === 'edit') {
                  alumnoActual.criterios[criterioIndex] = { alumnoId: alumnoActual.id,
                    criterioId: cambios['criterioId'], unidadEventoMateriaId: cambios['unidadEventoMateriaId']};
                }
              } else {
                if (cambios.accion === 'create') {
                  alumnoActual.criterios.push(
                    { alumnoId: alumnoActual.id, criterioId: cambios['criterioId'],
                      unidadEventoMateriaId: cambios['unidadEventoMateriaId']});
                }
              }

            }
          }
          // Cambios de estado de publicado.
          if (cambios['obj']) {
            if (cambios.accion === 'alumnos-update') {
              cambios['obj'].forEach(item => {
                const index = alumnos.findIndex(alumno => alumno.id === item.id);
                if (index > -1) {
                  alumnos[index].devuelto = item.devuelto;
                  alumnos[index].submission = item.submission || null;
                  if (item.eventoMateriaAlumnoConfig) {
                    alumnos[index]['eventoMateriaAlumnoConfig'] = item.eventoMateriaAlumnoConfig;
                  }
                }
              });
            }
          }
          return alumnos;
        } else {
          return alumnos;
        }
      })
    );
  }

  alumnosConSubmissions(alumnos$: Observable<AlumnoRetroalimentacion[]>, unidadEventoMateriaIds$: Observable<number[]>) {
    const studentSubmissions$ = unidadEventoMateriaIds$.pipe(
      flatMap(res => {
        return from(res).pipe(
          concatMap(data => {
            return this.classroomService.getStudentSubmissionsEvento(data);
          }),
          toArray(),
          map(data => {
            let submissionsArray = [];
            data.forEach(item => {
              submissionsArray = submissionsArray.concat(item);
            });
            return submissionsArray;
          })
        );
      }),
      shareReplay(1)
    );

    return combineLatest([studentSubmissions$, alumnos$]).pipe(
      map(([submissions, alumnos]) => {

        alumnos.forEach(element => {
          const submission = submissions.find(item => item.userId === element.providerKey);
          if (submission) {
            element.submission = submission;
          }
        });
        return alumnos;
      }),
      // Setting del menu de acciones.
      map(data => {
        data.forEach(alumno => {
          alumno.acciones = [];
          alumno.acciones.push({
            tipo: 'navegar',
            label: 'Vista individual',
            scope: 'local'
          });
          alumno.acciones.push({
            tipo:  alumno.devuelto ? 'despublicar' : 'publicar',
            label: alumno.devuelto ? 'Despublicar' : 'Publicar',
            scope: 'local'
          });
          alumno.acciones.push({
            tipo: 'comentar',
            label: 'Comentar',
            scope: 'local'
          });
          if (alumno.devuelto) {
            alumno.acciones.push(
              {
                tipo: 'publicar',
                label: 'Configurar autoevaluacion',
                scope: 'local'
              }
            );
          }
        });
        return data;
      }),
      shareReplay(1)
    );
  }

  ngOnDestroy(): void {
    if (this.alumnoFormSubscription) {
      this.alumnoFormSubscription.unsubscribe();
    }
  }

}
